/*
 * @Descripttion: 请求服务
 * @Author: Scarlett Xiao
 * @Date: 2021-12-21 15:58:24
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2021-12-21 15:58:24
 */
import axios from "axios";


axios.defaults.timeout = 60000 // 请求超时
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.baseURL = '/website-admin';

// request拦截器
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    console.error(error);
  }
);

// respone拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error(error);
  }
);


const http = {

  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @returns Promise
   */
  get(url, baseUrlType = null) {
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          res&&resolve(res.data);
        })
        .catch(err => {
          console.log(err);
          reject(err.data);
        });
    });
  },

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   * @returns Promise
   */
  post(url, params) {
    params = JSON.stringify(params).indexOf('"lang"') > -1 ? JSON.parse(JSON.stringify(params).replace(/\"lang\":\"zh\"/g, '"lang":"zh_CN"')) : params;
    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },

  postDownload(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          responseType: "blob", // 设置responseType对象格式为 blob:
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    })
  },

  /**
   * put方法，对应put请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   * @returns Promise
   */
  put(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, params)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },

  /**
   * 删除方法，对应delete请求
   * @param {String} url [请求的url地址]
   * @returns Promise
   */
  delete(url) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },
}

export default http;